import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=1cf93b8a"
import script from "./PriceSummary.vue?vue&type=script&lang=js"
export * from "./PriceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports